






















































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, max, regex } from 'vee-validate/dist/rules';
import { inquiryModule } from '@/contactus/store/modules/inquiry';

extend('required', required);
extend('email', email);
extend('max', max);
extend('regex', regex);

@Component({ components: { ValidationObserver, ValidationProvider } })
export default class ContactForm extends Vue {
    get subject(): string {
        return inquiryModule.subject;
    }
    set subject(value: string) {
        inquiryModule.SET_SUBJECT(value);
    }

    get message(): string {
        return inquiryModule.message;
    }
    set message(value: string) {
        inquiryModule.SET_MESSAGE(value);
    }

    get relatedContent(): string {
        return inquiryModule.relatedContent;
    }
    set relatedContent(value: string) {
        inquiryModule.SET_RELATED_CONTENT(value);
    }

    get name(): string {
        return inquiryModule.name;
    }
    set name(value: string) {
        inquiryModule.SET_NAME(value);
    }

    get email(): string {
        return inquiryModule.email;
    }
    set email(value: string) {
        inquiryModule.SET_EMAIL(value);
    }

    get company(): string {
        return inquiryModule.company;
    }
    set company(value: string) {
        inquiryModule.SET_COMPANY(value);
    }

    get isAgreed(): boolean {
        return inquiryModule.isAgreed;
    }
    set isAgreed(value: boolean) {
        inquiryModule.SET_IS_AGREED(value);
    }

    next() {
        this.$emit('change-page-confirm');
    }
}
